var exports = {
  "k": "x936d19a0--8cd0d3--cards",
};

module.exports = exports;
